console.log("Alternative Recommendation Engine Loaded");


//================================================
// CHECK PRODUCT FEATURE
//================================================

function productSupportsFeature(product, feature){

    const text = (

        (product.title || "") + " " +
        (product.product_type || "") + " " +
        (product.body_html || "") + " " +
        (product.tags || []).join(" ")

    ).toLowerCase();


    const keywords = FEATURE_KEYWORDS[feature];

    if(!keywords){

        return false;

    }


    return keywords.some(keyword =>
        text.includes(keyword.toLowerCase())
    );

}


//================================================
// COUNT FEATURE MATCHES
//================================================

function countFeatureMatches(product, requestedFeatures){

    let matched = 0;

    requestedFeatures.forEach(feature => {

        if(productSupportsFeature(product, feature)){

            matched++;

        }

    });

    return matched;

}


//================================================
// CALCULATE ALTERNATIVE SCORE
//================================================

function calculateAlternativeScore(
    product,
    requestedFeatures,
    budget
){

    const matchedFeatures =
        countFeatureMatches(
            product,
            requestedFeatures
        );


    //----------------------------------------
    // FEATURE SCORE
    //----------------------------------------

    let score = matchedFeatures * 20;


    //----------------------------------------
    // BUDGET SCORE
    //----------------------------------------

    const price = parseFloat(
        product?.variants?.[0]?.price || 0
    );


    if(
        budget &&
        price > 0 &&
        price <= budget.amount
    ){

        score += 20;

    }


    //----------------------------------------
    // LOWER PRICE BONUS
    //----------------------------------------

    if(
        budget &&
        price > 0 &&
        price <= budget.amount
    ){

        score += Math.max(
            0,
            10 - (price / budget.amount * 10)
        );

    }


    return score;

}


//================================================
// FIND ALTERNATIVES
//================================================

function findAlternativeProducts(
    products,
    requestedFeatures,
    budget
){

    if(!products || !products.length){

        return [];

    }


    //----------------------------------------
    // SCORE PRODUCTS
    //----------------------------------------

    let candidates = products.map(product => {

        const matchedFeatures =
            countFeatureMatches(
                product,
                requestedFeatures
            );


        return {

            product: product,

            matchedFeatures: matchedFeatures,

            score: calculateAlternativeScore(
                product,
                requestedFeatures,
                budget
            )

        };

    });


    //----------------------------------------
    // IMPORTANT:
    // PRODUCT MUST MATCH AT LEAST
    // ONE REQUESTED FEATURE
    //----------------------------------------

    if(requestedFeatures.length){

        candidates = candidates.filter(item =>

            item.matchedFeatures > 0

        );

    }


    //----------------------------------------
    // PREFER PRODUCTS WITHIN BUDGET
    //----------------------------------------

    if(budget){

        const underBudget =
            candidates.filter(item => {

                const price = parseFloat(
                    item.product?.variants?.[0]?.price || 0
                );

                return price > 0 &&
                       price <= budget.amount;

            });


        if(underBudget.length){

            candidates = underBudget;

        }

    }


    //----------------------------------------
    // SORT BY SCORE
    //----------------------------------------

    candidates.sort((a,b) => {

        if(b.matchedFeatures !== a.matchedFeatures){

            return b.matchedFeatures -
                   a.matchedFeatures;

        }

        return b.score - a.score;

    });


    //----------------------------------------
    // RETURN TOP 5
    //----------------------------------------

    return candidates
        .slice(0,5)
        .map(item => item.product);

}

function explainAlternative(product, requestedFeatures, budget){

    const matched = [];
    const missing = [];

    //----------------------------------------
    // CHECK REQUESTED FEATURES
    //----------------------------------------

    requestedFeatures.forEach(feature => {

        if(
            productSupportsFeature(
                product,
                feature
            )
        ){

            matched.push(feature);

        }
        else{

            missing.push(feature);

        }

    });


    //----------------------------------------
    // PRICE
    //----------------------------------------

    const price = parseFloat(
        product?.variants?.[0]?.price || 0
    );


    //----------------------------------------
    // BUDGET STATUS
    //----------------------------------------

    let budgetStatus = "unknown";

    if(budget && price > 0){

        if(price <= budget.amount){

            budgetStatus = "within_budget";

        }
        else{

            budgetStatus = "over_budget";

        }

    }


    //----------------------------------------
    // RETURN EXPLANATION
    //----------------------------------------

    return {

        product: product,

        matchedFeatures: matched,

        missingFeatures: missing,

        price: price,

        budgetStatus: budgetStatus

    };

}